import { Chip, IconButton, TableCell, TableHead, TableRow, Tooltip } from '@material-ui/core'
import { Delete, Edit, EventAvailable } from '@material-ui/icons'
import React from 'react'
import { StaffPujaAssignmentResponseType } from 'types/api/temple'

interface StaffAssignmentTableProps {
    assignments: StaffPujaAssignmentResponseType[]
    editHandler?: (id: string | number) => void
    deleteHandler?: (id: string | number) => void
    generateHandler?: (id: string | number) => void
    deletingIds?: (string | number)[]
}

const label = (value: string) => value.split('_').map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(' ')

const StaffAssignmentTable: React.FC<StaffAssignmentTableProps> = ({
    assignments,
    editHandler,
    deleteHandler,
    generateHandler,
    deletingIds = [],
}) => (
    <React.Fragment>
        <TableHead>
            <TableRow>
                <TableCell>Priest</TableCell>
                <TableCell>Offering</TableCell>
                <TableCell>Dates</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Recurrence</TableCell>
                <TableCell>Occurrences</TableCell>
                <TableCell>Status</TableCell>
                {(editHandler || deleteHandler || generateHandler) && <TableCell align='right'>Actions</TableCell>}
            </TableRow>
        </TableHead>
        {assignments.map(item => (
            <TableRow key={item.id}>
                <TableCell>{item.staffName}</TableCell>
                <TableCell>{item.offeringName}</TableCell>
                <TableCell>{item.startDate} to {item.endDate}</TableCell>
                <TableCell>{item.startTime} - {item.endTime}</TableCell>
                <TableCell>
                    {item.recurrence === 'none' ? 'None' : `${label(item.recurrence)} every ${item.recurrenceInterval}`}
                </TableCell>
                <TableCell>{item.occurrenceTotal}</TableCell>
                <TableCell>
                    <Chip
                        size='small'
                        color={item.status === 'scheduled' ? 'primary' : 'default'}
                        label={label(item.status)}
                    />
                </TableCell>
                {(editHandler || deleteHandler || generateHandler) && (
                    <TableCell align='right'>
                        {generateHandler && (
                            <Tooltip title='Generate occurrences'>
                                <IconButton onClick={() => generateHandler(item.id)}>
                                    <EventAvailable fontSize='small' />
                                </IconButton>
                            </Tooltip>
                        )}
                        {editHandler && (
                            <IconButton onClick={() => editHandler(item.id)}>
                                <Edit fontSize='small' />
                            </IconButton>
                        )}
                        {deleteHandler && (
                            <IconButton
                                disabled={deletingIds.includes(item.id)}
                                onClick={() => deleteHandler(item.id)}
                            >
                                <Delete fontSize='small' />
                            </IconButton>
                        )}
                    </TableCell>
                )}
            </TableRow>
        ))}
        {assignments.length === 0 && (
            <TableRow>
                <TableCell colSpan={8}>No staff assignments found</TableCell>
            </TableRow>
        )}
    </React.Fragment>
)

export default StaffAssignmentTable
